export default __webpack_public_path__ + "static/media/credfare.f1d4be52.png";